import { useEffect, useRef, useState } from 'react';
import { store } from '../state/store';
import { Icon } from './Icon';
import { t } from '../i18n/I18n';

/** Whether the demo walkthrough's hint was shown in this browser, as the app keeps `Settings.DemoModeHintShowed`. */
const HINT_KEY = 'hp.walkthrough-hint-shown';
const hintShown = () => { try { return localStorage.getItem(HINT_KEY) === '1'; } catch { return true; } };
const rememberHint = () => { try { localStorage.setItem(HINT_KEY, '1'); } catch { /* a private window keeps nothing: the hint shows again */ } };

/**
 * What the demo walkthrough keeps on screen (the app's EditorRoomMode.Demo): the way out, and the first time the app's
 * hint (DemoModeHintBalloon). Escape leaves too — the hint first, while it is open.
 */
export function WalkthroughChrome() {
  const [hint, setHint] = useState(() => !hintShown());
  const exit = useRef<HTMLButtonElement>(null), gotIt = useRef<HTMLButtonElement>(null);
  const closeHint = () => { rememberHint(); setHint(false); exit.current?.focus({ preventScroll: true }); };
  useEffect(() => { (hint ? gotIt : exit).current?.focus({ preventScroll: true }); }, []);
  useEffect(() => {
    const key = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      event.preventDefault();
      if (hint) closeHint(); else store.setWalkthrough(false);
    };
    window.addEventListener('keydown', key);
    return () => window.removeEventListener('keydown', key);
  }, [hint]);
  return <>
    <button ref={exit} type="button" className="walkthrough-exit glass" onClick={() => store.setWalkthrough(false)}><Icon name="back" size={18} /><span>{t('#EditorExitDemo')}</span></button>
    {hint && <div className="walkthrough-hint glass" role="dialog" aria-modal="false" aria-labelledby="walkthrough-hint-title">
      <h2 id="walkthrough-hint-title">{t('#DemoModeHintTitle')}</h2>
      <p>{t('#DemoModeHintDescription1')}</p>
      <p>{t('#DemoModeHintDescription2')}</p>
      <button ref={gotIt} type="button" onClick={closeHint}>{t('#GotIt')}</button>
    </div>}
  </>;
}
